import apiClient, { unwrap } from './client'
import type { Alias } from './types'

export const aliasesApi = {
  list() {
    return unwrap<Alias[]>(apiClient.get('/aliases'))
  },

  create(data: { domain_id: number; address: string; target: string }) {
    return unwrap<{ id: number }>(apiClient.post('/aliases', data))
  },

  delete(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/aliases/${id}`))
  },
}
